module.exports = __webpack_public_path__ + "img/QQ.b3da1c4f.jpg";